// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 95%;
  margin: 0 auto;
  border-radius: 8px;
  overflow: hidden;
  padding: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.jobs-page-container {
  padding: 15px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  box-sizing: border-box;
}

/* Search Bar */
.search-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  width: 100%;
  gap: 10px;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.search-input {
  padding: 10px;
  width: 60%;
  border-radius: 25px;
  border: 1px solid #f7f3f3;
  font-size: 14px;
  box-sizing: border-box;
}

.search-btn {
  padding: 10px 15px;
  border-radius: 25px;
  border: 1px solid #1e0675;
  background-color: #f5f5f5;
  cursor: pointer;
  font-size: 16px;
  box-sizing: border-box;
}

.filter {
  margin-right: 10px;
}

.filters {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  margin-bottom: 15px;
  flex-wrap: wrap;
  box-sizing: border-box;
}

.filters select {
  padding: 8px;
  border-radius: 5px;
  border: 1px solid #ccc;
  font-size: 14px;
  width: 45%;
  box-sizing: border-box;
  margin-bottom: 5px;
}

/* Job Listings */
.job-listings {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  width: 100%;
  box-sizing: border-box;
}

.job-card {
  border: 1px solid #ccc;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  gap: 10px;
  box-sizing: border-box;
}

.job-card h3 {
  margin: 0;
  font-size: 16px;
}

.job-card .company {
  font-size: 13px;
  color: #777;
}

.job-card .location,
.job-card .experience {
  font-size: 11px;
  color: #555;
}

.job-card .description {
  font-size: 13px;
  color: #333;
}

.apply-btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 13px;
  margin-top: 8px;
}

.apply-btn:hover {
  background-color: #218838;
}

.edit-btn {
  background-color: #006b8e;
  color: white;
  padding: 6px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}

.edit-btn:hover {
  background-color: #0056b3;
}

/* Edit Modal */
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  background-color: white;
  padding: 15px;
  border-radius: 10px;
  width: 90%;
  max-width: 400px;
  box-sizing: border-box;
}

.close {
      position: absolute;
      top: 10px;
      right: 10px;
      font-size: 25px;
      cursor: pointer;
    }

form {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

label {
  font-size: 13px;
  margin-bottom: 5px;
}

input,
textarea {
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
}

button {
  padding: 12px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}

button:hover {
  background-color: #218838;
}

.submission-message {
  text-align: center;
  font-size: 16px;
  color: green;
}

.submission-message h3 {
  font-weight: bold;
  font-size: 20px;
}

.submission-message p {
  font-size: 14px;
  color: #555;
}

.filters select:first-child, 
.filters select:last-child {
  width: 35%; 
}

.new-job-btn {
  background-color: #0073b1; /* LinkedIn blue */
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 15px;
}

.new-job-btn:hover {
  background-color: #005c8a;
}

.filters-container {
  display: flex;
  gap: 10px;
  margin-right: auto;
}

.search-more-container {
display: flex;
justify-content: center;
margin-top: 15px;
}

.search-more-btn {
background-color: #007bff;
color: white;
padding: 10px 20px;
border: none;
border-radius: 5px;
cursor: pointer;
font-size: 16px;
}


/* Media Queries */

/* Smaller phones */
@media (max-width: 320px) {
  .container {
    padding: 10px;
    width: 90%; /* Adjust width for smaller screens */
    margin: 0 auto; /* Center the container */
  }

  .search-input {
    font-size: 12px;
  }

  .search-btn {
    font-size: 14px;
    padding: 8px 10px;
  }

  .filters select {
    font-size: 12px;
  }

  .job-card h3 {
    font-size: 14px;
  }

  .job-card .company,
  .job-card .location,
  .job-card .experience,
  .job-card .description {
    font-size: 10px;
  }
}

/* Larger phones and tablets */
@media (min-width: 321px) and (max-width: 768px) {
  .container {
    padding: 12px;
    width: 90%; /* Adjust width for larger screens */
    margin: 0 auto; /* Center the container */
  }

  .search-input {
    width: 100%;
    font-size: 14px;
  }

  .search-btn {
    font-size: 16px;
    padding: 10px 15px;
  }

  .filters {
    flex-direction: column;
  }

  .filters select {
    width: 100%;
    margin-bottom: 10px;
  }

  .job-card h3 {
    font-size: 16px;
  }

  .job-card .company,
  .job-card .location,
  .job-card .experience,
  .job-card .description {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Job.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;MACM,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,eAAe;MACf,eAAe;IACjB;;AAEJ;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,yBAAyB,EAAE,kBAAkB;EAC7C,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;AACpB;;AAEA;AACA,aAAa;AACb,uBAAuB;AACvB,gBAAgB;AAChB;;AAEA;AACA,yBAAyB;AACzB,YAAY;AACZ,kBAAkB;AAClB,YAAY;AACZ,kBAAkB;AAClB,eAAe;AACf,eAAe;AACf;;;AAGA,kBAAkB;;AAElB,mBAAmB;AACnB;EACE;IACE,aAAa;IACb,UAAU,EAAE,qCAAqC;IACjD,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,aAAa;IACb,UAAU,EAAE,oCAAoC;IAChD,cAAc,EAAE,yBAAyB;EAC3C;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;IAIE,eAAe;EACjB;AACF","sourcesContent":[".container {\n  width: 95%;\n  margin: 0 auto;\n  border-radius: 8px;\n  overflow: hidden;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.jobs-page-container {\n  padding: 15px;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  box-sizing: border-box;\n}\n\n/* Search Bar */\n.search-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n  width: 100%;\n  gap: 10px;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n\n.search-input {\n  padding: 10px;\n  width: 60%;\n  border-radius: 25px;\n  border: 1px solid #f7f3f3;\n  font-size: 14px;\n  box-sizing: border-box;\n}\n\n.search-btn {\n  padding: 10px 15px;\n  border-radius: 25px;\n  border: 1px solid #1e0675;\n  background-color: #f5f5f5;\n  cursor: pointer;\n  font-size: 16px;\n  box-sizing: border-box;\n}\n\n.filter {\n  margin-right: 10px;\n}\n\n.filters {\n  display: flex;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  margin-bottom: 15px;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n}\n\n.filters select {\n  padding: 8px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  font-size: 14px;\n  width: 45%;\n  box-sizing: border-box;\n  margin-bottom: 5px;\n}\n\n/* Job Listings */\n.job-listings {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));\n  gap: 15px;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.job-card {\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  padding: 15px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  box-sizing: border-box;\n}\n\n.job-card h3 {\n  margin: 0;\n  font-size: 16px;\n}\n\n.job-card .company {\n  font-size: 13px;\n  color: #777;\n}\n\n.job-card .location,\n.job-card .experience {\n  font-size: 11px;\n  color: #555;\n}\n\n.job-card .description {\n  font-size: 13px;\n  color: #333;\n}\n\n.apply-btn {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  padding: 8px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 13px;\n  margin-top: 8px;\n}\n\n.apply-btn:hover {\n  background-color: #218838;\n}\n\n.edit-btn {\n  background-color: #006b8e;\n  color: white;\n  padding: 6px 12px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n}\n\n.edit-btn:hover {\n  background-color: #0056b3;\n}\n\n/* Edit Modal */\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-content {\n  background-color: white;\n  padding: 15px;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 400px;\n  box-sizing: border-box;\n}\n\n.close {\n      position: absolute;\n      top: 10px;\n      right: 10px;\n      font-size: 25px;\n      cursor: pointer;\n    }\n\nform {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\nlabel {\n  font-size: 13px;\n  margin-bottom: 5px;\n}\n\ninput,\ntextarea {\n  padding: 10px;\n  font-size: 14px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n}\n\nbutton {\n  padding: 12px;\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\nbutton:hover {\n  background-color: #218838;\n}\n\n.submission-message {\n  text-align: center;\n  font-size: 16px;\n  color: green;\n}\n\n.submission-message h3 {\n  font-weight: bold;\n  font-size: 20px;\n}\n\n.submission-message p {\n  font-size: 14px;\n  color: #555;\n}\n\n.filters select:first-child, \n.filters select:last-child {\n  width: 35%; \n}\n\n.new-job-btn {\n  background-color: #0073b1; /* LinkedIn blue */\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 15px;\n}\n\n.new-job-btn:hover {\n  background-color: #005c8a;\n}\n\n.filters-container {\n  display: flex;\n  gap: 10px;\n  margin-right: auto;\n}\n\n.search-more-container {\ndisplay: flex;\njustify-content: center;\nmargin-top: 15px;\n}\n\n.search-more-btn {\nbackground-color: #007bff;\ncolor: white;\npadding: 10px 20px;\nborder: none;\nborder-radius: 5px;\ncursor: pointer;\nfont-size: 16px;\n}\n\n\n/* Media Queries */\n\n/* Smaller phones */\n@media (max-width: 320px) {\n  .container {\n    padding: 10px;\n    width: 90%; /* Adjust width for smaller screens */\n    margin: 0 auto; /* Center the container */\n  }\n\n  .search-input {\n    font-size: 12px;\n  }\n\n  .search-btn {\n    font-size: 14px;\n    padding: 8px 10px;\n  }\n\n  .filters select {\n    font-size: 12px;\n  }\n\n  .job-card h3 {\n    font-size: 14px;\n  }\n\n  .job-card .company,\n  .job-card .location,\n  .job-card .experience,\n  .job-card .description {\n    font-size: 10px;\n  }\n}\n\n/* Larger phones and tablets */\n@media (min-width: 321px) and (max-width: 768px) {\n  .container {\n    padding: 12px;\n    width: 90%; /* Adjust width for larger screens */\n    margin: 0 auto; /* Center the container */\n  }\n\n  .search-input {\n    width: 100%;\n    font-size: 14px;\n  }\n\n  .search-btn {\n    font-size: 16px;\n    padding: 10px 15px;\n  }\n\n  .filters {\n    flex-direction: column;\n  }\n\n  .filters select {\n    width: 100%;\n    margin-bottom: 10px;\n  }\n\n  .job-card h3 {\n    font-size: 16px;\n  }\n\n  .job-card .company,\n  .job-card .location,\n  .job-card .experience,\n  .job-card .description {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
